// @mui material components
import Tooltip from "@mui/material/Tooltip";

// Dashboard React components
import DSBox from "components/DSBox";
import DSTypography from "components/DSTypography";
import DSAvatar from "components/DSAvatar";
import DSProgress from "components/DSProgress";

// Custom styles for the Projects
import styles from "layouts/dashboard/components/Projects/styles";

// Images
import logoXD from "assets/images/small-logos/logo-xd.svg";
import logoAtlassian from "assets/images/small-logos/logo-atlassian.svg";
import logoSlack from "assets/images/small-logos/logo-slack.svg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
import logoJira from "assets/images/small-logos/logo-jira.svg";
import logoInvesion from "assets/images/small-logos/logo-invision.svg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

export default function data() {
  const classes = styles();

  const avatars = (members) =>
    members.map(([image, name]) => (
      <Tooltip key={name} title={name} placeholder="bottom">
        <DSAvatar src={image} alt="name" size="xs" customClass={classes.projects_tableAvatar} />
      </Tooltip>
    ));

  return {
    
    columns: [
      { name: "segment", align: "left" },
      { name: "team", align: "center" },
      { name: "budget", align: "center" },
      { name: "performance", align: "center" },
    ],

    rows: [
      {
        segment: (
          <DSTypography variant="caption" textColor="text" fontWeight="medium">
            Snacks
          </DSTypography>
        ),
        team: (
          <DSBox display="flex" py={1}>
            {avatars([
              [team1, "Ryan Tompson"],
              [team3, "Alexander Smith"],
              [team3, "Aniston Smith"],
              [team4, "Jessica Doe"],
            ])}
          </DSBox>
        ),
        budget: (
          <DSTypography variant="caption" textColor="text" fontWeight="medium">
            $320,000
          </DSTypography>
        ),
        performance: (
          <DSBox width="8rem" textAlign="left">
            <DSProgress value={100} color="success" gradient />
          </DSBox>
        ),
      },
      {
        segment: (
          <DSTypography variant="caption" textColor="text" fontWeight="medium">
            Soft Drinks
          </DSTypography>
        ),
        team: (
          <DSBox display="flex" py={1}>
            {avatars([
              [team1, "Ryan Tompson"],
              [team2, "Romina Hadid"],
              
            ])}
          </DSBox>
        ),
        budget: (
          <DSTypography variant="caption" textColor="text" fontWeight="medium">
            $140,000
          </DSTypography>
        ),
        performance: (
          <DSBox width="8rem" textAlign="left">
            <DSProgress value={60} color="info" gradient />
          </DSBox>
        ),
      },
      {
        segment: (
          <DSTypography variant="caption" textColor="text" fontWeight="medium">
            Baked Goods
          </DSTypography>
        ),
        team: (
          <DSBox display="flex" py={1}>
            {avatars([
              [team1, "Ryan Tompson"],
              [team2, "Mariana Pelt"],
              
            ])}
          </DSBox>
        ),
        budget: (
          <DSTypography variant="caption" textColor="text" fontWeight="medium">
            $120,000
          </DSTypography>
        ),
        performance: (
          <DSBox width="8rem" textAlign="left">
            <DSProgress value={30} color="warning" gradient />
          </DSBox>
        ),
      },
      {
        segment: (
          <DSTypography variant="caption" textColor="text" fontWeight="medium">
            Charcuterie
          </DSTypography>
        ),
        team: (
          <DSBox display="flex" py={1}>
            {avatars([
              [team2, "Miles Medin"],
              [team3, "Pula Anna"],
              [team1, "Romina Hadid"],
              
            ])}
          </DSBox>
        ),
        budget: (
          <DSTypography variant="caption" textColor="text" fontWeight="medium">
            $110,000
          </DSTypography>
        ),
        performance: (
          <DSBox width="8rem" textAlign="left">
            <DSProgress value={90} color="info" gradient />
          </DSBox>
        ),
      }

    ],
  };
}
